import React, {useEffect, useState} from "react";
import {useCart} from "../Cart/CartContext";
import "./ProductQuantity.css";
import {ProductData} from "@/components/Cart/cart.dto";

interface ProductQuantityProps {
    quantity: number,
    productMultiplier: number,
    setQuantity: React.Dispatch<React.SetStateAction<number>>,
    OnNegativeQuantity?: (() => void),
    productData: ProductData
}

const ProductQuantity: React.FC<ProductQuantityProps> = ({
                                                             quantity,
                                                             productMultiplier,
                                                             setQuantity,
                                                             OnNegativeQuantity,
                                                             productData
                                                         }) => {
    const {cart, updateCartItemQuantity} = useCart();
    const [loaded, setLoaded] = useState(false);

    const handleDecreaseQuantity = async () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
            updateCartItemQuantity(productData.id, quantity, productData.isTransit);
        } else if (OnNegativeQuantity)
            OnNegativeQuantity();
    }

    function handleIncreaseQuantity() {
        setQuantity(quantity + 1);
        updateCartItemQuantity(productData?.id, quantity, productData.isTransit);
    }

    function handleOnChange(ev: React.ChangeEvent<HTMLInputElement>) {
        let newQuantity = ev.target.valueAsNumber;
        if (isNaN(newQuantity)) {
            setQuantity(1);
            return;
        }

        if (newQuantity < 1) {
            if (OnNegativeQuantity) {
                OnNegativeQuantity();
            }
            newQuantity = 1;
        }

        setQuantity(newQuantity);
    }

    useEffect(() => {
        // setQuantity(productData.quantity);
        let cartItem;
        if(productData.isTransit) {
            cartItem = cart?.items.transitItems.filter(item => item.articleId === productData.id)
        } else {
            cartItem = cart?.items.stockItems.filter(item => item.articleId === productData.id);
        }
        
        if (!loaded && cartItem && cartItem.length > 0) {
            setQuantity(cartItem[0].quantity);
            setLoaded(true);
        }
    }, [cart, loaded, productData.id, productData.isTransit, setQuantity]);

    return (
        <div>
            <label htmlFor="Quantity" className="sr-only"> Quantity </label>

            <div className="mx-1">
                <div className="flex flex-row">
                    <div className="flex items-center rounded border border-gray-200">
                        <button type="button" className="size-10 leading-10 text-gray-600 transition hover:opacity-75"
                                onClick={handleDecreaseQuantity}>
                            -
                        </button>

                        <input
                            type="number"
                            id="Quantity"
                            value={quantity}
                            onChange={handleOnChange}
                            onKeyDown={(e) => {
                                if ([".", ",", "-"].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            onPaste={(e) => {
                                const pastedData = e.clipboardData.getData("Text");
                                if (!/^\d+$/.test(pastedData)) {
                                    e.preventDefault();
                                }
                            }}
                            className="flex-grow h-10 w-16 border-transparent text-center [-moz-appearance:_textfield] sm:text-sm [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none"
                        />

                        <button type="button" className="size-10 leading-10 text-gray-600 transition hover:opacity-75"
                                onClick={handleIncreaseQuantity}>
                            +
                        </button>
                    </div>
                    <div className="mt-2 ml-2">
                        {Number.parseFloat((productMultiplier * quantity).toFixed(2))} {productData.salesUnit === "K" ? "kilograme" : "bucati"} 
                    </div>
                </div>
            </div>
        </div>);
}

export default ProductQuantity;